import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { USDFormatterAutoRound } from '../utils/number';
import { StyledInput } from './components';
import { formatAmountString, getCaretPosition, getStringVariables } from './helpers';
/*  INSTRUCTIONS

  To force an error state use the error prop.

  To have component handle max and min value errors you have to include the handleErrors prop
  as well as the max and min values

  handleChange is used to get the value back from the Currency Input

  maxWholeDollarDigits is used as a max input length controller. 5 is a 100,000 max thus capping inputs at 99,999.99
*/

export var CURRENCY_INPUT_ID = 'currency_input';
export var parseDollarString = function parseDollarString(dollarString) {
  return parseFloat(dollarString.replace('$', '').replace(',', ''));
};

var CurrencyInputV2 = function CurrencyInputV2(_ref) {
  var _ref$maxWholeDollarDi = _ref.maxWholeDollarDigits,
      maxWholeDollarDigits = _ref$maxWholeDollarDi === void 0 ? 5 : _ref$maxWholeDollarDi,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '$0' : _ref$placeholder,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      maxValue = _ref.maxValue,
      minValue = _ref.minValue,
      handleErrors = _ref.handleErrors,
      handleChange = _ref.handleChange,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
      _ref$overrideValue = _ref.overrideValue,
      overrideValue = _ref$overrideValue === void 0 ? null : _ref$overrideValue,
      _ref$decimalKeyboard = _ref.decimalKeyboard,
      decimalKeyboard = _ref$decimalKeyboard === void 0 ? false : _ref$decimalKeyboard;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      dollarAmount = _useState2[0],
      setDollarAmount = _useState2[1];

  var _useState3 = useState(dollarAmount ? '$' + dollarAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : ''),
      _useState4 = _slicedToArray(_useState3, 2),
      dollarAmountString = _useState4[0],
      setDollarAmountString = _useState4[1];

  var getMax = function getMax() {
    var generatedMaxValue = Math.pow(10, maxWholeDollarDigits);

    if (handleErrors) {
      return maxValue ? maxValue > generatedMaxValue ? Math.pow(10, Math.round(maxValue).toString().length) : generatedMaxValue : generatedMaxValue;
    } else {
      return maxValue ? maxValue : generatedMaxValue;
    }
  };

  var onDollarAmountChange = function onDollarAmountChange(e) {
    var element = e.target;

    var _getStringVariables = getStringVariables(element.value, dollarAmountString),
        _getStringVariables2 = _slicedToArray(_getStringVariables, 3),
        formattedEventString = _getStringVariables2[0],
        unformattedString = _getStringVariables2[1],
        numericalString = _getStringVariables2[2];

    var caret = null;
    var formattedDollarString = formatAmountString(formattedEventString.split('.'));

    if (parseInt(numericalString, 10) < getMax()) {
      var _element$selectionSta;

      caret = getCaretPosition((_element$selectionSta = element.selectionStart) !== null && _element$selectionSta !== void 0 ? _element$selectionSta : 0, dollarAmountString, formattedDollarString, unformattedString);
      setDollarAmountString(formattedDollarString);
      setDollarAmount(parseDollarString(formattedDollarString));
    } else if (parseInt(numericalString, 10) >= 0) {
      var _element$selectionSta2;

      caret = (_element$selectionSta2 = element.selectionStart) !== null && _element$selectionSta2 !== void 0 ? _element$selectionSta2 : 1 - 1;
    } else {
      setDollarAmountString(formattedEventString);
      setDollarAmount(0);
    }

    window.requestAnimationFrame(function () {
      element.selectionStart = caret;
      element.selectionEnd = caret;
    });
  };

  var dollarAmountBlur = function dollarAmountBlur() {
    if (dollarAmount) {
      setDollarAmountString(USDFormatterAutoRound(parseDollarString(dollarAmountString)));
    } else {
      setDollarAmount(0);
      setDollarAmountString('');
    }
  };

  useEffect(function () {
    handleChange(dollarAmount);
  }, [dollarAmount]);
  useEffect(function () {
    if (overrideValue !== null) {
      setDollarAmount(overrideValue);
      setDollarAmountString(formatAmountString(overrideValue.toString().split('.')));
    }
  }, [overrideValue]);

  var getError = function getError() {
    if (error) {
      return 'error';
    } else if (handleErrors) {
      if (dollarAmount && minValue && dollarAmount < minValue) {
        return 'error';
      } else if (maxValue && maxValue < dollarAmount) {
        return 'error';
      }
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(StyledInput, {
    placeholder: placeholder,
    onChange: onDollarAmountChange,
    value: dollarAmountString,
    autoFocus: autoFocus,
    onBlur: dollarAmountBlur,
    error: getError(),
    length: dollarAmountString.length,
    "data-testid": CURRENCY_INPUT_ID,
    inputMode: decimalKeyboard ? 'decimal' : 'text'
  });
};

export { CurrencyInputV2 };